import { render, staticRenderFns } from "./transccless.vue?vue&type=template&id=bb2a2670&scoped=true"
import script from "./transccless.vue?vue&type=script&lang=js"
export * from "./transccless.vue?vue&type=script&lang=js"
import style0 from "./transccless.vue?vue&type=style&index=0&id=bb2a2670&prod&scoped=true&lang=scss"
import style1 from "./transccless.vue?vue&type=style&index=1&id=bb2a2670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2a2670",
  null
  
)

export default component.exports